import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import {
  AuthenticatedResult,
  LoginResponse,
  OidcSecurityService,
} from 'angular-auth-oidc-client';
import { filter, switchMap, tap } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-login-callback',
  imports: [CommonModule, MatProgressSpinnerModule, MatCardModule],
  templateUrl: './login-callback.component.html',
  styleUrl: './login-callback.component.scss',
})
export class LoginCallbackComponent implements OnInit {
  private readonly _oidcSecurityService = inject(OidcSecurityService);
  private readonly _authenticationService = inject(AuthService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.initSubscriptions();
  }

  initSubscriptions() {
    this._oidcSecurityService.isAuthenticated$
      .pipe(
        tap((isAuthenticatedResult: AuthenticatedResult) => {
          console.log(isAuthenticatedResult);
        }),
        filter(
          (isAuthenticatedResult: AuthenticatedResult) =>
            isAuthenticatedResult.isAuthenticated
        ),
        tap(() => {
          this._authenticationService.token =
            this._authenticationService.accessToken$.getValue();
        }),
        switchMap(() => this._oidcSecurityService.getPayloadFromIdToken())
      )
      .subscribe({
        next: () => {
          this.router.navigateByUrl('/home');
        },
        complete: () => {
          this._authenticationService.token =
            this._authenticationService.accessToken$.getValue();
        },
      });
  }

  subscribeToAuthCheck() {
    this._authenticationService.checkAuth().subscribe({
      next: (loginResponses: LoginResponse) => {
        const { isAuthenticated, userData, accessToken, idToken, configId } =
          loginResponses;
        this.handleLoginResponse(loginResponses);
      },
      complete: () => {
        console.log('Complete Check Auth Multiple');
      },
    });
  }

  handleLoginResponse(loginResponse: LoginResponse) {
    console.warn(loginResponse);

    if (loginResponse.isAuthenticated) {
      this._authenticationService.setLoginResponse(loginResponse);
    }
    this._authenticationService.setLoading(false);
  }
}
